<template>
  <q-page class="container" padding>
    <div class="row col-12">
      <p class="text-h6 text-brand-5 text-weight-bold">
        Criar Checklist de Controle
      </p>
    </div>
    <q-form ref="myForm" @submit.prevent="onSubmit">
      <div class="row col-12 q-col-gutter-sm q-mt-md">
        <div class="col-md-2 col-sm-12 col-xs-12 text-brand-5 text-weight-bold">
          Unidade
          <lista-unidades-select v-model="unidade"></lista-unidades-select>
        </div>
        <div class="col-md-6 col-sm-12 col-xs-12 text-brand-5 text-weight-bold">
          O que deve ser verificado antes da Devolução do Item?
          <q-input
            dense
            outlined
            v-model="checklist.descricao"
            :rules="[(val) => (val && val.length > 0) || 'Campo Obrigatório']"
          >
          </q-input>
        </div>

        <div class="col-md-2 col-sm-12 col-xs-12">
          <p></p>
          <q-btn
            class="q-mt-sm"
            color="positive"
            icon="add"
            label="Adicionar"
            no-caps
            type="submit"
            @click="criar()"
          />
        </div>
      </div>
    </q-form>

    <div class="text-brand-5 text-weight-bold q-my-xl">
      <upload-component
        :titulo="'Enviar planilha de produtos'"
        :template="'ferramenta-checklist'"
      />
    </div>
    <p class="text-body1 text-brand-5 text-weight-bold q-mt-xl">
      Lista de Verificações
    </p>
    <q-btn
      class="q-mt-sm"
      color="secondary"
      label="Baixar Template"
      no-caps
      href="https://cdn.multpex.com.br/templates/ferramentas/ferramentas-checklist.xlsx"
      target="_blank"
      icon="browser_updated"
    />
    <div class="q-mt-lg">
      <q-table
        flat
        table-header-class="bg-accent text-width-bold"
        id="customers"
        class="q-mt-sm tabela-tamanho-fixo"
        dense
        :rows="listaChecklist"
        :columns="columns"
        :loading="disable"
        :rows-per-page-options="[0]"
        hide-bottom
      >
        <template v-slot:body="props">
          <q-tr :props="props">
            <q-td class="text-left" key="descricao" :props="props">
              {{ props.row.descricao }}
            </q-td>
            <q-td class="text-left" key="descricao" :props="props">
              {{ props.row.checklistId }}
            </q-td>
            <q-td class="text-left">
              <q-btn
                flat
                style="color: red"
                label="Remover"
                no-caps
                icon="remove_circle_outline"
                @click="deletar([props.row.checklistId])"
              />
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </div>
  </q-page>
</template>

<script>
import UploadComponent from "../components/UploadComponent.vue";
import { ref, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";

export default {
  name: "Checklist",
  components: { UploadComponent, ListaUnidadesSelect },
  setup() {
    const emitir = ref({
      unidade: "",
      local: "",
      descricao: "",
      dataInicio: new Date().toLocaleString("pt-br"),
      dataTermino: new Date().toLocaleString("pt-br"),
    });

    const unidade = ref();

    const disable = ref(true);

    const checklist = ref({
      descricao: "",
    });

    const listaChecklist = ref([]);
    const $q = useQuasar();
    const myForm = ref(null);
    const store = useStore();
    const columns = [
      {
        name: "descricao",
        label: "Verificaçãoes",
        field: "descricao",
        align: "left",
        sortable: true,
      },
      {
        name: "checklistId",
        label: "ID",
        field: "checklistId",
        align: "left",
        sortable: true,
      },
      {
        name: "",
        label: "Remover",
        field: "",
        align: "left",
      },
    ];

    let listarChecklist = async () => {
      try {
        let resposta = await store.dispatch("fer/listarChecklist", {
          unidadeId: emitir.value.unidade.id,
        });
        listaChecklist.value = resposta.listaChecklist;
        disable.value = false;
      } catch (error) {
        console.error(error);
      }
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        emitir.value.unidade = store.state.org.unidadeData;
        listarChecklist();
      }
    );

    const getUnidade = () => {
      if (!store.state.org.unidadeData) {
        return;
      }
      emitir.value.unidade = store.state.org.unidadeData;
    };

    onMounted(() => {
      getUnidade();
      listarChecklist();
    });

    let deletar = async (checklistId) => {
      let resposta = confirm(`Deseja excluir o checklist ${checklistId}? `);
      if (resposta == true) {
        try {
          await store.dispatch("fer/deletarChecklist", {
            checklistId: checklistId,
          });

          alert("Checklist Excluido com Sucesso!");
          listarChecklist();
        } catch (error) {
          console.log(error);
        }
      }
    };

    let criar = async () => {
      let sucess = await myForm.value.validate();
      if (!sucess) {
        return;
      }

      try {
        await store.dispatch("fer/criarChecklist", {
          descricao: checklist.value.descricao,
          unidadeId: emitir.value.unidade.id,
        });

        $q.notify({
          message: "Checklist Cadastrado!",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        reset();
        onReset();
        listarChecklist();
      } catch (e) {
        if (e.request.status < 500) {
          for (let index in e.response.data.errors) {
            $q.notify({
              message: e.response.data.errors[index],
              color: "negative",
              actions: [
                {
                  label: "Fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
          }
        }

        if (e.request.status >= 500) {
          $q.notify({
            message: "Erro no servidor, tente novamente",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const onReset = async () => {
      await reset();
      myForm.value.resetValidation();
    };

    const reset = async () => {
      checklist.value = {};
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        unidade.value = store.state.org.unidadeData;
      }
    );

    return {
      criar,
      deletar,
      myForm,
      listaChecklist,
      listarChecklist,
      columns,
      emitir,
      getUnidade,
      checklist,
      disable,
      unidade,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
</style>
